var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionButtonDel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9987 7.20861L16.7902 6L12 10.792L7.20849 6L6 7.20861L10.7915 12.0006L6 16.7914L7.20849 18L12 13.208L16.7915 18L18 16.7914L13.2085 12.0006L17.9987 7.20861Z",
    fill: "#DA0B0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionButtonDel);
export default __webpack_public_path__ + "static/media/actionButtonDel.5a4920df5e22138bed2726504ae367c3.svg";
export { ForwardRef as ReactComponent };